import SexoCombobox from "./SexoCombobox.vue";

export {SexoCombobox}
export default SexoCombobox
